import { ApolloError } from '@apollo/client';

export const parseError = (errors?: ApolloError): string | null => {
  const networkErrors = errors?.networkError?.message || null;
  const gqlErrors = errors?.graphQLErrors.map(e => e.message).join('\n') || null;

  return networkErrors ?? gqlErrors;
};
